import { render, staticRenderFns } from "./ShareWallet.vue?vue&type=template&id=08700acd"
import script from "./ShareWallet.vue?vue&type=script&lang=js"
export * from "./ShareWallet.vue?vue&type=script&lang=js"
import style0 from "./ShareWallet.vue?vue&type=style&index=0&id=08700acd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports